import React from "react";
import {
  Box,
  Card,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip
} from "@mui/material";

const ScopeAccreditation = ({ data, labType }) => {
  if (!data || data.length === 0) return null;

  return (
    <Box sx={{ mb: 4 }}>
      <Card elevation={3}>
        {/* HEADER */}
        <Typography
          variant="h6"
          sx={{ 
            fontWeight: "bold", 
            bgcolor: "#e3f2fd", 
            p: 1, 
            mb: 1,
            textAlign: "center" 
          }}
        >
          Scope of Accreditation (Form 72)
        </Typography>

        <TableContainer
          component={Paper}
          sx={{ mb: 3, borderRadius: 0, maxWidth: "100%", mx: "auto", overflowX: "auto" }}
        >
          <Table
            size="small"
            sx={{
              border: "1px solid #bdbdbd",
              "& th, & td": { border: "1px solid #bdbdbd" },
              borderCollapse: "collapse",
              minWidth: 1200
            }}
          >
            <TableHead>
              <TableRow sx={{ bgcolor: "#dbd8d8c7" }}>
                <TableCell align="center" sx={{ minWidth: 50, fontSize: "0.82rem", fontWeight: "bold" }}>
                  Sr No.
                </TableCell>
                <TableCell align="center" sx={{ minWidth: 120, fontSize: "0.82rem", fontWeight: "bold" }}>
                  Assessor Details
                </TableCell>
                <TableCell align="center" sx={{ minWidth: 80, fontSize: "0.82rem", fontWeight: "bold" }}>
                  Discipline
                </TableCell>
                <TableCell align="center" sx={{ minWidth: 250, fontSize: "0.82rem", fontWeight: "bold" }}>
                  Scope Details
                </TableCell>
                <TableCell align="center" sx={{ minWidth: 200, fontSize: "0.82rem", fontWeight: "bold" }}>
                  Range & Standards
                </TableCell>
                <TableCell align="center" sx={{ minWidth: 150, fontSize: "0.82rem", fontWeight: "bold" }}>
                  Assessment Details
                </TableCell>
                <TableCell align="center" sx={{ minWidth: 120, fontSize: "0.82rem", fontWeight: "bold" }}>
                  Status
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((item, index) => (
                <TableRow
                  key={index}
                  sx={{
                    "&:nth-of-type(odd)": {
                      backgroundColor: "#f9f9f9"
                    },
                    "&:hover": {
                      backgroundColor: "#f0f7ff"
                    }
                  }}
                >
                  <TableCell align="center" sx={{ fontSize: "0.82rem", verticalAlign: "top" }}>
                    {index + 1}
                  </TableCell>
                  <TableCell align="left" sx={{ fontSize: "0.82rem", verticalAlign: "top" }}>
                    <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                      <div><strong>Name:</strong> {item.AssessorName || "-"}</div>
                    </div>
                  </TableCell>
                  <TableCell align="left" sx={{ fontSize: "0.82rem", verticalAlign: "top" }}>
                    {item.disciplineName || "-"}
                  </TableCell>
                  <TableCell align="left" sx={{ fontSize: "0.82rem", verticalAlign: "top" }}>
                    <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                      <div><strong>Test Code:</strong> {item.testCode || "-"}</div>
                      <div><strong>Materials/Products Tested:</strong> {item.GroupTested || "-"}</div>
                      <div><strong>Specific Test Performed:</strong> {item.TypeOfTest || "-"}</div>
                      <div><strong>Test Method/Equipment Used:</strong> {item.scopeStandard || "-"}</div>
                    </div>
                  </TableCell>
                  <TableCell align="left" sx={{ fontSize: "0.82rem", verticalAlign: "top" }}>
                    <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                      <div><strong>Type:</strong> {item.rangeType || "-"}</div>
                      <div><strong>Facility:</strong> {item.testPerformedAt || "-"}</div>
                      <div><strong>Range:</strong> {item.unit || "-"}</div>
                      <div><strong>%CV / MU:</strong> CV:{item.cv || "-"}/MU:{item.mu || "-"}</div>
                    </div>
                  </TableCell>
                  <TableCell align="left" sx={{ fontSize: "0.82rem", verticalAlign: "top" }}>
                    <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                      <div><strong>Assessment Technique:</strong> {item.assessmentTechniqueUsed || item.scopeStandard || "-"}</div>
                      {item.Remarks && (
                        <div><strong>Remarks:</strong> {item.Remarks}</div>
                      )}
                    </div>
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{ fontSize: "0.82rem", verticalAlign: "top" }}
                  >
                    <Chip
                      label={item.status || "N/A"}
                      size="small"
                      sx={{
                        backgroundColor:
                          item.status === "Adequate"
                            ? "#4caf50"
                            : item.status === "Inadequate"
                            ? "#f44336"
                            : item.status === "Not Applicable"
                            ? "#ff9800"
                            : "#9e9e9e",
                        color: "#fff",
                        fontWeight: 700,
                        fontSize: "0.75rem",
                        mb: 1
                      }}
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Card>
    </Box>
  );
};

export default ScopeAccreditation;
